import { Component, OnInit } from "@angular/core";
import { iM } from "@angular/core/src/render3";
import { ServicesService } from "../../services/services.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import swal from "sweetalert2";

@Component({
  selector: "app-maintenance-history",
  templateUrl: "./maintenance-history.component.html",
  styleUrls: ["./maintenance-history.component.css"],
})
export class MaintenanceHistoryComponent implements OnInit {
  maintenanceHistoryForm: FormGroup;
  data: any[] = [];
  selectedMaintenance: any;
  public routePath;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _services: ServicesService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    // Retrieve 'projectData' from local storage
    const projectDataString = localStorage.getItem("selectedMaintenanceData");

    if (projectDataString) {
      // Parse 'projectData' string to an object
      this.data = JSON.parse(projectDataString);

      console.log("Correct data:", this.data);
    }

    this.maintenanceHistoryForm = this.formBuilder.group({
      municipality: ["", Validators.required],
      project_type: ["", Validators.required],
      job_type: ["", Validators.required],
      frequency: ["", Validators.required],
      center_name: ["", Validators.required],
      description: ["", Validators.required],
      address: ["", Validators.required],
      employee: ["", Validators.required],
      name: ["", Validators.required],
      surname: ["", Validators.required],
      employee_name: ["", Validators.required],
      employee_surname: ["", Validators.required],
      employee_signature: ["", Validators.required],
      client_name: ["", Validators.required],
      client_surname: ["", Validators.required],
      client_signature: ["", Validators.required],
      client_comment: ["", Validators.required],
    });
  }

  generateReportPDF() {
    this.routePath = "resume";
    this._services
    //@ts-ignore
      .requestCreatorPDF({ jobid: this.data.id }, this.routePath, this._services.getToken())
      .subscribe((data: Blob) => {
        const blob = new Blob([data], { type: "application/pdf" });
    
        // Create a link element to download the PDF
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "maintenance-pdf-v2.pdf";
    
        // Append the link element to the document and trigger a click event to initiate the download
        document.body.appendChild(a);
        a.click();
    
        // Cleanup: remove the link element and revoke the Blob URL
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      });
    
    this.router.navigate(["/generate-note-number"]);
  }
}
